(() => {
  document.documentElement.classList.replace('no-js', 'js');
  const reducedQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const reduced = () => reducedQuery.matches || document.body.dataset.motion === 'false';
  let toastTimer;
  function toast(message) {
    const box = document.querySelector('[data-toast]');
    if (!box) return;
    box.textContent = message;
    box.classList.add('visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => box.classList.remove('visible'), 4000);
  }
  document.querySelectorAll('[data-motion-toggle]').forEach(button => {
    const sync = () => button.setAttribute('aria-pressed', String(reduced()));
    sync();
    button.addEventListener('click', () => {
      document.body.dataset.motion = document.body.dataset.motion === 'false' ? 'true' : 'false';
      try { localStorage.setItem('afterdark-motion', document.body.dataset.motion); } catch {}
      window.dispatchEvent(new Event('afterdark:motion'));
      sync();
    });
    reducedQuery.addEventListener('change', sync);
  });
  function wireDialog(dialog) {
    if (!dialog || dialog.dataset.wired) return;
    dialog.dataset.wired = 'true';
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.querySelectorAll('[data-close-dialog],[data-close-image]').forEach(button => button.addEventListener('click', () => dialog.close()));
  }
  document.querySelectorAll('dialog').forEach(wireDialog);
  function initProduct(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const image = root.querySelector('.gallery-image');
    const imageDialog = root.querySelector('[data-image-dialog]');
    wireDialog(imageDialog);
    function setImage(src, alt) {
      if (!src || !image) return;
      image.removeAttribute('srcset');
      image.src = src;
      if (alt) image.alt = alt;
    }
    root.querySelectorAll('[data-gallery-image]').forEach(button => button.addEventListener('click', () => {
      setImage(button.dataset.galleryImage, button.dataset.galleryAlt);
      root.querySelectorAll('[data-gallery-image]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    }));
    root.querySelector('[data-zoom]')?.addEventListener('click', () => {
      const expanded = imageDialog.querySelector('img');
      expanded.src = image.currentSrc || image.src;
      expanded.alt = image.alt;
      imageDialog.showModal();
    });
    const form = root.querySelector('.product-form');
    if (!form) return;
    const select = form.querySelector('[data-variant]');
    const add = form.querySelector('[data-add]');
    const label = add.querySelector('[data-add-label]');
    const quantity = form.querySelector('[name=quantity]');
    function variantChange() {
      const option = select.selectedOptions[0];
      root.querySelector('[data-price]').textContent = option.dataset.price;
      const compare = root.querySelector('[data-compare]');
      if (compare) compare.hidden = true;
      add.disabled = option.dataset.available !== 'true';
      label.textContent = add.disabled ? add.dataset.sold : add.dataset.label;
      setImage(option.dataset.image);
      if (location.pathname.includes('/products/')) {
        const url = new URL(location.href); url.searchParams.set('variant', select.value); history.replaceState({}, '', url);
      }
    }
    select.addEventListener('change', variantChange);
    form.querySelectorAll('[data-quantity-step]').forEach(button => button.addEventListener('click', () => {
      quantity.value = Math.max(1, Math.min(99, (parseInt(quantity.value,10) || 1) + Number(button.dataset.quantityStep)));
      quantity.dispatchEvent(new Event('change', {bubbles:true}));
    }));
    form.addEventListener('submit', async event => {
      if (!window.fetch || !window.FormData) return;
      event.preventDefault();
      if (!form.reportValidity() || add.disabled) return;
      const error = form.querySelector('[data-form-error]');
      error.textContent = '';
      add.disabled = true; label.textContent = add.dataset.loading;
      const data = new FormData(form);
      const base = window.Shopify?.routes?.root || '/';
      try {
        if (document.body.dataset.preview === 'true') {
          await new Promise(resolve => setTimeout(resolve, 250));
          const count = Number(document.querySelector('[data-cart-count]').textContent) + Number(quantity.value);
          document.querySelectorAll('[data-cart-count]').forEach(node => node.textContent = count);
          window.AfterdarkPreview?.save(count);
          const dialog = document.querySelector('[data-cart-dialog]');
          dialog.querySelector('[data-added-title]').textContent = `${quantity.value} × The Crawl · Preview only`;
          dialog.showModal();
          return;
        }
        const response = await fetch(base + 'cart/add.js', {method:'POST',headers:{Accept:'application/json'},body:data});
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : add.dataset.error);
        try {
          const cartResponse = await fetch(base + 'cart.js', {headers:{Accept:'application/json'}});
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            document.querySelectorAll('[data-cart-count]').forEach(node => node.textContent = cart.item_count);
          }
        } catch {}
        const dialog = document.querySelector('[data-cart-dialog]');
        if (dialog?.showModal) {
          dialog.querySelector('[data-added-title]').textContent = `${quantity.value} × ${result.product_title || result.title}`;
          dialog.showModal();
        } else { location.href = base + 'cart'; }
      } catch (exception) {
        error.textContent = exception.message || add.dataset.error;
      } finally {
        add.disabled = select.selectedOptions[0].dataset.available !== 'true';
        label.textContent = add.disabled ? add.dataset.sold : add.dataset.label;
      }
    });
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-product-section]').forEach(initProduct);
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
